import Item from './Item';
import MediaItem from './MediaItem';

const Menu = ( props = {menuItems: [], style: {}} ) =>
    <nav style={props.style}
         className="nav-submenu hidden absolute border-l border-grey-lighter overflow-y-auto">
            <ul className="list-reset m-0">
                {props.menuItems.map( renderMenuItem )}
            </ul>
        </nav>

Menu.item = Item;
Menu.mediaItem = MediaItem;

function renderMenuItem ( node ) {
    const Component = /chemistries/.test( node.url )
        ? Menu.mediaItem
        : Menu.item;

    return <Component {...node} />;
}

export default Menu;